// extracted by mini-css-extract-plugin
export default {"p":"a76570b2fe _3fea3c2d42 _96c4b08aaa","clr":"_0976ad2578","dls":"_3cc78e66b6"};